//Models
PJQ.models.billing = {};

PJQ.models.billing.BillingInfo = PJQ.models.BaseModel.extend({
	endpoint: '/billing',
	getCardholderName: function () {
		let name = this.get('firstName');
		if (_.size(this.get('lastName')) > 0) {
			name = ' ' + this.get('lastName');
		}
		return name;
	},
	save: function (mod, opts = {}) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'billing'
				}
			]),
			data: this.toJSON()
		}).put().done(_.bind(function (data) {
			if (data == null || data.subscription == null) {
				//empty the card number in case of error after this point
				this.set({
					cardNumber: null,
					cardExpirationMonth: null,
					cardExpirationYear: null
				});

				if (typeof opts.error === 'function') {
					opts.error(data);
				}
			}

			if (data.billingInfo != null) {
				this.parse(data.billingInfo);
			}

			PJQ.app.session.subscriptionChanged(data.subscription);

			if (typeof opts.success === 'function') {
				opts.success(data);
			}
		}, this)).fail(_.bind(function (data) {
			//empty the card number in case of error after this point
			this.set({
				cardNumber: null,
				cardExpirationMonth: null,
				cardExpirationYear: null
			});

			if (typeof opts.error === 'function') {
				opts.error(data);
			}
		}, this));
	},
	parse(model) {
		if (!model)
			return model;

		this.attributes = model;
	}
});
